// When a browser blocks site storage (Chrome's "Block all cookies", some
// privacy modes), merely touching window.localStorage throws a SecurityError.
// The app reads it during its first render - the saved page, the language, the
// theme - so a reader with storage blocked got "Something went wrong" on every
// load. Here, before anything else runs, a blocked localStorage is replaced by
// an in-memory stand-in: the site works, it just forgets on reload, which is
// what that reader asked their browser for.
//
// Imported first in main.tsx, so it is in place before any module evaluates.

function storageWorks(): boolean {
  try {
    const s = window.localStorage;
    const k = '__mm_probe__';
    s.setItem(k, '1');
    s.removeItem(k);
    return true;
  } catch {
    return false;
  }
}

if (typeof window !== 'undefined' && !storageWorks()) {
  const mem = new Map<string, string>();
  const shim: Storage = {
    get length() { return mem.size; },
    clear: () => mem.clear(),
    getItem: (k: string) => (mem.has(k) ? (mem.get(k) as string) : null),
    key: (i: number) => [...mem.keys()][i] ?? null,
    removeItem: (k: string) => { mem.delete(k); },
    setItem: (k: string, v: string) => { mem.set(k, String(v)); },
  };
  try { Object.defineProperty(window, 'localStorage', { configurable: true, value: shim }); } catch { /* nothing more to do */ }
}

export {};
